import { useAppMessages } from 'hooks/useAppMessages';
import { useIntl } from 'react-intl';
import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';
import { InventoryLocations as messages } from '../../messages';
import { GetLocationMetersArg, GetLocationMetersResponse } from '../../../services/api/inventoryLocations';

interface UseCombinedMeters {
  id?: GetLocationMetersArg['id'];
  filter?: GetLocationMetersArg['filter'];
  onSuccess?: (data: GetLocationMetersResponse) => void;
}

export const useCombinedMeters = (
  { id, filter }: UseCombinedMeters,
  options: UseQueryOptions<GetLocationMetersResponse> = {},
): UseQueryResult<GetLocationMetersResponse> => {
  const intl = useIntl();
  const appMessages = useAppMessages();
  const {
    api: { inventoryLocationsApiClient },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.inventoryLocations.getLocationMeters(filter),
    queryFn: async ({ signal }) => await inventoryLocationsApiClient.getLocationMeters({ id, filter, signal }),
    onError: () => appMessages.error(intl.formatMessage(messages.noCombinedMetersFound)),
    ...options,
  });
};
